import { API_ORDER } from 'utils/constants'
import Api from './axiosInstance'

type FetchOpenOrdersParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

export const fetchPosOpenOrders = ({
  limit,
  page,
  search,
  filters,
}: FetchOpenOrdersParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_ORDER.OPEN_ORDERS}?${params}`,
  })
}

export const fetchPosOpenOrder = (orderId: string) => {
  return Api.get({ url: `${API_ORDER.OPEN_ORDERS}/${orderId}` })
}

export const fetchPosOpenOrderCounts = () => {
  return Api.get({
    url: `${API_ORDER.OPEN_ORDERS}/counts`,
  })
}
